import React, { FunctionComponent } from 'react';
import { useCss } from 'app/utils/css';
import { HTTP_STATUS_PAGE_MEDIUM_BREAKPOINT } from 'app/constants/Breakpoints';
import FontStyles from 'app/components/layout/FontStyles';
import H1, { H1Variant } from 'app/components/common/H1';
import H2, { H2Variant } from 'app/components/common/H2';
import getHttpStatusOwl from 'app/components/svgs/mascot/HttpStatusOwl';
import useMeasure from 'app/components/layout/useMeasure';

interface IProps {
  status: number;
  header: string;
  message: string;
}

const HttpStatusPageContent: FunctionComponent<IProps> = ({ status, header, message }) => {
  const css = useCss();

  const statusHeader = `${status}`;
  const httpStatusOwl = getHttpStatusOwl(status);

  const [size, measureRef] = useMeasure();
  const wide = size.width >= HTTP_STATUS_PAGE_MEDIUM_BREAKPOINT;

  return (
    <div
      className={css('fontStylesContainer', {
        // Disable flexGrow for <FontStyles>
        flexGrow: 0,
      })}
      ref={measureRef}
    >
      <FontStyles>
        <div
          className={css('container', {
            display: 'flex',
            flexWrap: 'wrap-reverse',
            justifyContent: 'space-around',
            fontWeight: 600,
            marginTop: wide ? '0' : '3em',
          })}
        >
          <div
            className={css('details', {
              margin: wide ? '2em 0 0 0' : '0 1em 1em 1em',
              maxWidth: wide ? '550px' : '350px',
            })}
          >
            <H1 variant={H1Variant.H1_HTTP_STATUS_STYLE}>{statusHeader}</H1>

            <div className={css('headersContainer', { marginTop: '1em' })}>
              {header!.split('\n').map((line, key) => (
                <H2 variant={H2Variant.H2_HTTP_STATUS_STYLE} key={key}>
                  {line}
                </H2>
              ))}
            </div>

            <div
              className={css('messagesContainer', {
                marginTop: wide ? '2em' : '1.5em',
              })}
            >
              {message!.split('\n').map((line, key) => (
                <p key={key} className={css('message', { margin: '4px 0' })}>
                  {line}
                </p>
              ))}
            </div>
          </div>
          {httpStatusOwl && (
            <div
              className={css('owl', {
                display: 'flex',
                alignSelf: 'flex-end',
                flexBasis: wide ? '400px' : '250px',
                height: wide ? '400px' : '250px',
                margin: wide ? '2em 0 0 0' : '1em 0 0 0',
              })}
            >
              {httpStatusOwl}
            </div>
          )}
        </div>
      </FontStyles>
    </div>
  );
};

export default HttpStatusPageContent;
